import Swal from 'sweetalert2';

export const swalSuccess = (text) =>
  Swal.fire({
    icon: 'success',
    title: 'Sucesso',
    text,
    timer: 2500,
    showConfirmButton: false,
  });

export const swalError = (text) =>
  Swal.fire({
    icon: 'error',
    title: 'Erro',
    text,
  });

export const swalConfirm = ({ title = 'Tem certeza?', text, confirmText = 'Sim', cancelText = 'Cancelar' } = {}) =>
  Swal.fire({
    icon: 'warning',
    title,
    text,
    showCancelButton: true,
    confirmButtonText: confirmText,
    cancelButtonText: cancelText,
    confirmButtonColor: '#d33',
    cancelButtonColor: '#6c757d',
  });
